const mockCountrylistFromJson = (fields) => {
  if (!fields) {
    return {};
  }
  if (!fields.countryList) {
    return fields;
  }
  try {
    const json = fields.countryList.value;
    const parsed = JSON.parse(json);
    const Elements = parsed.values.map((element) => ({
      fields: {
        Title: {
          value: element.title,
        },
        Value: {
          value: element.value,
        },
      },
    }));
    const defaultOption = {};
    if (parsed.default) {
      defaultOption['Default Option'] = {
        fields: {
          Value: {
            value: parsed.default,
          },
        },
      };
    }
    return {
      debugZoomLevels: fields.debugZoomLevels,
      countryList: {
        fields: {
          ...defaultOption,
          Elements,
        },
      },
    };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('Could not create mock countrylist from fields', e, fields);
    return null;
  }
};

const getSelectList = (fields, fieldsName, fallbackValue, sortAlphabetically) => {
  if (IS_SHOWROOM) {
    if (
      fields?.[fieldsName] &&
      typeof fields[fieldsName].value === 'string' &&
      !fields[fieldsName].fields
    ) {
      fields[fieldsName] = mockCountrylistFromJson(fields)[fieldsName];
    }
  }
  if (!(fields?.[fieldsName] && fields[fieldsName].fields?.Elements)) {
    return [null, fallbackValue];
  }

  let selectList;
  if (fieldsName === 'targetGroupSectorList') {
    fields[fieldsName].fields.Elements.forEach((element) => {
      if (!element.fields) {
        console.error('"fields" are not defined');
        return;
      }

      if (!element.fields.Title) {
        console.error('"Title" is not defined (field: "targetGroupSectorList")', element);
      }
      if (!element.fields.Value) {
        console.error('"Value" is not defined (field: "targetGroupSectorList")', element);
      }
      if (!element.fields.Image) {
        console.error('"Image" is not defined (field: "targetGroupSectorList")', element);
      }
    });

    selectList = fields[fieldsName].fields.Elements.map((element) => ({
      title: element.fields.Title.value || element.fields.Value.value,
      name: element.fields.Title.value || element.fields.Value.value,
      value: element.fields.Value.value,
      image: element.fields.Image ? element.fields.Image.value : undefined,
      newsletter: element.fields.Newsletter ? element.fields.Newsletter.id : '',
    }));
  } else {
    selectList = fields[fieldsName].fields.Elements.map((element) => ({
      title: element.fields.Title.value || element.fields.Value.value,
      name: element.fields.Title.value || element.fields.Value.value,
      value: element.fields.Value.value,
    }));
  }

  const defaultField = fields[fieldsName].fields['Default Option'];
  let defaultOption;
  let defaultValue;

  if (defaultField) {
    defaultValue = defaultField.fields.Value.value;
    defaultOption = selectList.find((el) => el.value === defaultValue);
  } else {
    defaultOption = null;
  }

  if (sortAlphabetically) {
    selectList.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
  }

  return [defaultOption, selectList, defaultValue];
};

const getApiSelectList = (data, fieldsName, fallbackValue, sortAlphabetically) => {
  if (IS_SHOWROOM) {
    if (data?.[fieldsName] && typeof data[fieldsName] === 'string' && !data[fieldsName]) {
      data[fieldsName] = mockCountrylistFromJson(data)[fieldsName];
    }
  }
  if (!(data?.[fieldsName] && data[fieldsName]?.Elements)) {
    return [null, fallbackValue];
  }

  let selectList;
  if (fieldsName === 'TargetGroupSectorList') {
    data[fieldsName].Elements.forEach((element) => {
      if (!element) {
        console.error('"fields" are not defined');
        return;
      }

      if (!element.Title) {
        console.error('"Title" is not defined (field: "TargetGroupSectorList")', element);
      }
      if (!element.Value) {
        console.error('"Value" is not defined (field: "TargetGroupSectorList")', element);
      }
    });

    selectList = data[fieldsName].Elements?.map((element) => ({
      title: element.Title || element.Value,
      name: element.Title || element.Value,
      value: element.Value,
      newsletter: element.Newsletter || '',
    }));
  } else {
    selectList = data[fieldsName].Elements?.map((element) => ({
      title: element.Title || element.Value,
      name: element.Title || element.Value,
      value: element.Value,
    }));
  }

  const defaultField = data[fieldsName]['Default_Option'];
  let defaultOption;
  let defaultValue;

  if (defaultField) {
    defaultValue = defaultField.Value;
    defaultOption = selectList.find((el) => el.value === defaultValue);
  } else {
    defaultOption = null;
  }

  if (sortAlphabetically) {
    selectList.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
  }

  return [defaultOption, selectList, defaultValue];
};

const mockChannel = (fields, $fischer) => {
  if (!IS_SHOWROOM) {
    // eslint-disable-next-line no-console
    console.log('Called dev-tool outside of showroom!');
    return;
  }
  if (fields?.mockChannel?.value) {
    const locale = fields.mockChannel.value;
    $fischer.setCatalogSetting('locale', locale);
    $fischer.showroomOverrides.setContext('language', locale.replace('_', '-'));
  }
  if (fields?.mockBaseSiteId) {
    const baseSiteId = fields.mockBaseSiteId.value;
    $fischer.setShopSetting('baseSiteId', baseSiteId);
  }
};

const getSplitted = (obj) => {
  let result = [];

  if (!obj?.value) {
    return result;
  }

  if (obj.value.indexOf('{0}') !== -1) {
    result = obj.value.split('{0}');
  } else {
    result.push(obj.value);
  }

  return result;
};

const getPreparedPlaceholderValue = (fields, fieldName, placeholderValue) => {
  const obj = fields[fieldName];
  let value = '';

  if (obj?.value?.indexOf('{0}') !== -1) {
    value = getSplitted(obj)[0] + placeholderValue + getSplitted(obj)[1];
  } else if (obj?.value) {
    value = obj.value;
  }

  return value;
};

export {
  getSelectList,
  getApiSelectList,
  mockCountrylistFromJson,
  mockChannel,
  getPreparedPlaceholderValue,
  getSplitted,
};
